import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { ReactNode } from 'react';

import type { VariableSourceRowDragHandleProps } from '../types';

export interface SortableVariableItemProps {
  /** Key of the row; one of the `itemIds` of the enclosing `SortableVariableList`. */
  id: string;
  /** Receives the props the row spreads onto its drag handle. */
  children: (dragHandleProps: VariableSourceRowDragHandleProps) => ReactNode;
}

/** One draggable row of the variable list: applies the drag animation and
 * hands the row the props for its drag handle. */
export const SortableVariableItem = ({ id, children }: SortableVariableItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        position: 'relative',
        zIndex: isDragging ? 1 : undefined,
      }}
    >
      {children({ attributes, listeners })}
    </div>
  );
};
